import script from "./DuplicateVisitWarning.vue?vue&type=script&setup=true&lang=js"
export * from "./DuplicateVisitWarning.vue?vue&type=script&setup=true&lang=js"

import "./DuplicateVisitWarning.vue?vue&type=style&index=0&id=5fde3cba&lang=css"

const __exports__ = script;

export default __exports__